import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dialog } from 'primereact/dialog';
import { useDownload } from '../../Hooks/layout/useDownload';
import QRCode from 'react-qr-code';
import { useCommon } from '../../Hooks/Common/useCommon.js';

const DownloadApp = ({ handleClose, downloadPopup, deviceType }) => {
    const { qrValue, expired, handleRefresh, openPopup, setOpenPopup, uploadAPK, handleUpload, tagRef } = useDownload({ deviceType });
    const { checkPermission } = useCommon();

    return (
        <>
            <Dialog draggable={false} header="Download App" visible={downloadPopup} className="modal-small" onHide={handleClose} >


                <div className='text-right mb-2' ref={() => checkPermission("download", tagRef)}>
                    <button ref={tagRef} id='{"tabname": "dashboard", "data": "apk_upload_btn"}' onClick={() => setOpenPopup(true)}>+ APK</button>
                </div>
                {!expired ? (
                    <>
                        <div className='d-flex justify-content-between align-items-center px-2 my-2'>
                            <div className='d-flex flex-column align-items-center bg-light rounded border p-4' >
                                <h5 className='fw-semibold text-center fw-semibold text-success'>Android</h5>
                                <QRCode value={qrValue?.androidQr ? qrValue?.androidQr : ""} style={{ width: "110px", height: "110px" }} className='my-2' />
                                <p>Scan to download APK</p>
                            </div>
                            <h5 className='fw-bold'>
                                OR
                            </h5>
                            <div className='d-flex flex-column align-items-center bg-light rounded border p-4'  >
                                <h5 className='fw-semibold text-center text-primary fw-semibold'>IOS</h5>
                                <QRCode value={qrValue?.iosQR ? qrValue?.iosQR : ""} style={{ width: "110px", height: "110px" }} className='my-2' />
                                <p>Scan to install on iPhone</p>
                            </div>
                        </div>
                    </>
                ) : (
                    <div className='text-center'>
                        <button className='c-pointer button btn-default my-3 py-2' onClick={handleRefresh}>
                            <FontAwesomeIcon icon="fa-solid fa-arrows-rotate" title="Refresh" style={{ fontSize: "20px" }} />
                        </button>
                        <p className='text-danger bold text-center'>QR code has expired. Please refresh to generate a new one.</p>
                    </div>
                )}


            </Dialog>


            <Dialog draggable={false} header="Upload APK" visible={openPopup} className="modal-xsmall" onHide={() => setOpenPopup(false)} >
                <div>
                    <label>Upload APK File</label><br />
                    <input
                        type="file"
                        className="input-text w100"
                        accept=".apk"
                        onChange={handleUpload}
                    />
                </div>
                <div className='d-flex justify-content-end my-2'>
                    <button className='btn-primary' onClick={uploadAPK}>Submit</button>
                </div>
            </Dialog>

        </>
    );
};

export default DownloadApp;
